export const FETCH_BUDDIES_FACETS_REQUEST = 'FETCH_BUDDIES_FACETS_REQUEST';
export const FETCH_BUDDIES_FACETS_SUCCESS = 'FETCH_BUDDIES_FACETS_SUCCESS';
export const FETCH_BUDDIES_FACETS_FAIL = 'FETCH_BUDDIES_FACETS_FAIL';

export const SET_BUDDIES_FILTERS = 'SET_BUDDIES_FILTERS';
export const RESET_BUDDIES_FILTERS = 'RESET_BUDDIES_FILTERS';

export const FETCH_PERSONAL_NETWORK_USERS_REQUEST = 'FETCH_PERSONAL_NETWORK_USERS_REQUEST';
export const FETCH_PERSONAL_NETWORK_USERS_SUCCESS = 'FETCH_PERSONAL_NETWORK_USERS_SUCCESS';
export const FETCH_PERSONAL_NETWORK_USERS_FAIL = 'FETCH_PERSONAL_NETWORK_USERS_FAIL';

export const FETCH_PERSONAL_NETWORK_USER_DETAIL_REQUEST = 'FETCH_PERSONAL_NETWORK_USER_DETAIL_REQUEST';
export const FETCH_PERSONAL_NETWORK_USER_DETAIL_SUCCESS = 'FETCH_PERSONAL_NETWORK_USER_DETAIL_SUCCESS';
export const FETCH_PERSONAL_NETWORK_USER_DETAIL_FAIL = 'FETCH_PERSONAL_NETWORK_USER_DETAIL_FAIL';

export const FETCH_PERSONAL_NETWORK_COMPANY_DETAIL_REQUEST = 'FETCH_PERSONAL_NETWORK_COMPANY_DETAIL_REQUEST';
export const FETCH_PERSONAL_NETWORK_COMPANY_DETAIL_SUCCESS = 'FETCH_PERSONAL_NETWORK_COMPANY_DETAIL_SUCCESS';
export const FETCH_PERSONAL_NETWORK_COMPANY_DETAIL_FAIL = 'FETCH_PERSONAL_NETWORK_COMPANY_DETAIL_FAIL';

export const DELETE_PERSONAL_NETWORK_USER_REQUEST = 'DELETE_PERSONAL_NETWORK_USER_REQUEST';
export const DELETE_PERSONAL_NETWORK_USER_SUCCESS = 'DELETE_PERSONAL_NETWORK_USER_SUCCESS';
export const DELETE_PERSONAL_NETWORK_USER_FAIL = 'DELETE_PERSONAL_NETWORK_USER_FAIL';

export const INVITE_PERSONAL_NETWORK_USER_REQUEST = 'INVITE_PERSONAL_NETWORK_USER_REQUEST';
export const INVITE_PERSONAL_NETWORK_USER_SUCCESS = 'INVITE_PERSONAL_NETWORK_USER_SUCCESS';
export const INVITE_PERSONAL_NETWORK_USER_FAIL = 'INVITE_PERSONAL_NETWORK_USER_FAIL';

export const FETCH_PERSONAL_NETWORK_SENT_INVITATION_REQUEST = 'FETCH_PERSONAL_NETWORK_SENT_INVITATION_REQUEST';
export const FETCH_PERSONAL_NETWORK_SENT_INVITATION_SUCCESS = 'FETCH_PERSONAL_NETWORK_SENT_INVITATION_SUCCESS';
export const FETCH_PERSONAL_NETWORK_SENT_INVITATION_FAIL = 'FETCH_PERSONAL_NETWORK_SENT_INVITATION_FAIL';

export const FETCH_PERSONAL_NETWORK_RECEIVED_INVITATION_REQUEST = 'FETCH_PERSONAL_NETWORK_RECEIVED_INVITATION_REQUEST';
export const FETCH_PERSONAL_NETWORK_RECEIVED_INVITATION_SUCCESS = 'FETCH_PERSONAL_NETWORK_RECEIVED_INVITATION_SUCCESS';
export const FETCH_PERSONAL_NETWORK_RECEIVED_INVITATION_FAIL = 'FETCH_PERSONAL_NETWORK_RECEIVED_INVITATION_FAIL';

export const FETCH_PERSONAL_NETWORK_CONNECTION_REQUEST = 'FETCH_PERSONAL_NETWORK_CONNECTION_REQUEST';
export const FETCH_PERSONAL_NETWORK_CONNECTION_SUCCESS = 'FETCH_PERSONAL_NETWORK_CONNECTION_SUCCESS';
export const FETCH_PERSONAL_NETWORK_CONNECTION_FAIL = 'FETCH_PERSONAL_NETWORK_CONNECTION_FAIL';

export const ACCEPT_PERSONAL_NETWORK_INVITATION_REQUEST = 'ACCEPT_PERSONAL_NETWORK_INVITATION_REQUEST';
export const ACCEPT_PERSONAL_NETWORK_INVITATION_SUCCESS = 'ACCEPT_PERSONAL_NETWORK_INVITATION_SUCCESS';
export const ACCEPT_PERSONAL_NETWORK_INVITATION_NOTIFY = 'ACCEPT_PERSONAL_NETWORK_INVITATION_NOTIFY';
export const ACCEPT_PERSONAL_NETWORK_INVITATION_FAIL = 'ACCEPT_PERSONAL_NETWORK_INVITATION_FAIL';

export const REJECT_PERSONAL_NETWORK_INVITATION_REQUEST = 'REJECT_PERSONAL_NETWORK_INVITATION_REQUEST';
export const REJECT_PERSONAL_NETWORK_INVITATION_SUCCESS = 'REJECT_PERSONAL_NETWORK_INVITATION_SUCCESS';
export const REJECT_PERSONAL_NETWORK_INVITATION_NOTIFY = 'REJECT_PERSONAL_NETWORK_INVITATION_NOTIFY';
export const REJECT_PERSONAL_NETWORK_INVITATION_FAIL = 'REJECT_PERSONAL_NETWORK_INVITATION_FAIL';

export const SET_FAVORITE_PERSONAL_NETWORK_USER_REQUEST = 'SET_FAVORITE_PERSONAL_NETWORK_USER_REQUEST';
export const SET_FAVORITE_PERSONAL_NETWORK_USER_SUCCESS = 'SET_FAVORITE_PERSONAL_NETWORK_USER_SUCCESS';
export const SET_FAVORITE_PERSONAL_NETWORK_USER_FAIL = 'SET_FAVORITE_PERSONAL_NETWORK_USER_FAIL';

export const DELETE_PERSONAL_NETWORK_CONNECTION_REQUEST = 'DELETE_PERSONAL_NETWORK_CONNECTION_REQUEST';
export const DELETE_PERSONAL_NETWORK_CONNECTION_SUCCESS = 'DELETE_PERSONAL_NETWORK_CONNECTION_SUCCESS';
export const DELETE_PERSONAL_NETWORK_CONNECTION_SUCCESS_NOTIFY = 'DELETE_PERSONAL_NETWORK_CONNECTION_SUCCESS_NOTIFY';
export const DELETE_PERSONAL_NETWORK_CONNECTION_FAIL = 'DELETE_PERSONAL_NETWORK_CONNECTION_FAIL';

export const DELETE_CORPORATE_NETWORK_CONNECTION_REQUEST = 'DELETE_CORPORATE_NETWORK_CONNECTION_REQUEST';
export const DELETE_CORPORATE_NETWORK_CONNECTION_SUCCESS = 'DELETE_CORPORATE_NETWORK_CONNECTION_SUCCESS';
export const DELETE_CORPORATE_NETWORK_CONNECTION_FAIL = 'DELETE_CORPORATE_NETWORK_CONNECTION_FAIL';

export const FETCH_PERSONAL_NETWORK_CONTACTS_REQUEST = 'FETCH_PERSONAL_NETWORK_CONTACTS_REQUEST';
export const FETCH_PERSONAL_NETWORK_CONTACTS_SUCCESS = 'FETCH_PERSONAL_NETWORK_CONTACTS_SUCCESS';
export const FETCH_PERSONAL_NETWORK_CONTACTS_FAIL = 'FETCH_PERSONAL_NETWORK_CONTACTS_FAIL';

export const BULK_ADD_PERSONAL_NETWORK_CONTACTS_REQUEST = 'BULK_ADD_PERSONAL_NETWORK_CONTACTS_REQUEST';
export const BULK_ADD_PERSONAL_NETWORK_CONTACTS_SUCCESS = 'BULK_ADD_PERSONAL_NETWORK_CONTACTS_SUCCESS';
export const BULK_ADD_PERSONAL_NETWORK_CONTACTS_FAIL = 'BULK_ADD_PERSONAL_NETWORK_CONTACTS_FAIL';

export const DELETE_PERSONAL_NETWORK_CONTACT_REQUEST = 'DELETE_PERSONAL_NETWORK_CONTACT_REQUEST';
export const DELETE_PERSONAL_NETWORK_CONTACT_SUCCESS = 'DELETE_PERSONAL_NETWORK_CONTACT_SUCCESS';
export const DELETE_PERSONAL_NETWORK_CONTACT_FAIL = 'DELETE_PERSONAL_NETWORK_CONTACT_FAIL';

export const FETCH_BUDDIES_REQUEST = 'FETCH_BUDDIES_REQUEST';
export const FETCH_BUDDIES_SUCCESS = 'FETCH_BUDDIES_SUCCESS';
export const FETCH_BUDDIES_FAIL = 'FETCH_BUDDIES_FAIL';

export const FETCH_NEXT_BUDDIES_REQUEST = 'FETCH_NEXT_BUDDIES_REQUEST';
export const FETCH_NEXT_BUDDIES_SUCCESS = 'FETCH_NEXT_BUDDIES_SUCCESS';
export const FETCH_NEXT_BUDDIES_FAIL = 'FETCH_NEXT_BUDDIES_FAIL';